import { AHIcon, AHText, Box } from "arkh";
import React from "react";
import { graphql, useFragment } from "react-relay";
import { TodoOverviewListItemMediumDescription_Todo$key } from "./__generated__/TodoOverviewListItemMediumDescription_Todo.graphql";
import { TodoSubject, TodoSubjectExcludeRoot } from "./TodoSubject/TodoSubject";
import { useIntl } from "react-intl";

export const TodoOverviewListItemMediumDescription = React.memo(
  TodoOverviewListItemMediumDescription_
);
function TodoOverviewListItemMediumDescription_(props: {
  todo: TodoOverviewListItemMediumDescription_Todo$key;
  breadcrumbsExcludeRoot?: boolean;
}) {
  const todo = useFragment(
    graphql`
      fragment TodoOverviewListItemMediumDescription_Todo on Todo {
        title

        isIssue
        subject {
          ...TodoSubject_TodoSubject
          ...TodoSubjectExcludeRoot_TodoSubject
        }
        images {
          __typename
        }
        files {
          __typename
        }
      }
    `,
    props.todo
  );

  const intl = useIntl();
  const placeholder = intl.formatMessage({
    defaultMessage: "Issue",
    description: "Issue placeholder label",
  });

  return (
    <Box
      style={{
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        flex: 1,
      }}
    >
      <Box style={{ flexDirection: "row", alignItems: "center", flex: 1 }}>
        {todo.subject ? (
          props.breadcrumbsExcludeRoot ? (
            <TodoSubjectExcludeRoot
              subject={todo.subject}
              placeholder={todo.isIssue ? placeholder : undefined}
              trailingBreadcrumb={todo.title}
              onlyRequired
            />
          ) : (
            <TodoSubject
              subject={todo.subject}
              trailingBreadcrumb={todo.title}
              highlightLast
              onlyRequired
            />
          )
        ) : (
          <AHText
            style={{ flex: 1 }}
            numberOfLines={1}
            type="subtitle"
            color="text-primary"
            ellipsizeMode="tail"
          >
            {todo.title}
          </AHText>
        )}
      </Box>
      {(todo.images?.length ?? 0) > 0 ? (
        <AHIcon
          type="image"
          color="washedText"
          size="xsmall"
          spaceLeft="small"
        />
      ) : null}
      {(todo.files?.length ?? 0) > 0 ? (
        <AHIcon
          type="files"
          color="washedText"
          size="xsmall"
          spaceLeft="small"
        />
      ) : null}
    </Box>
  );
}
